var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-light mt-5 pt-5 pb-5"},[_c('div',{staticClass:"container-fluid text-center"},[_c('span',{staticStyle:{"font-weight":"300"}},[_c('small',[_vm._v("© "+_vm._s(_vm.currentYear)+" All Rights reserved | ULGA")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }